var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoreholeHovered(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "15px",
    viewBox: "0 0 16 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BH") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Screens",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Full-value-Map-Search",
    transform: "translate(-599.000000, -518.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CPT-mark",
    transform: "translate(599.000000, 518.000000)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1",
    transform: "matrix(0.054191, 0, 0, 0.054191, 0.518677, 0)",
    style: {}
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 136.27,
    cy: 138.4,
    r: 90.82,
    style: {
      fill: "none",
      stroke: "#5ADACC",
      strokeMiterlimit: 10,
      strokeWidth: 33
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 272.54,
    y1: 138.4,
    y2: 138.4,
    style: {
      fill: "none",
      stroke: "#5ADACC",
      strokeMiterlimit: 10,
      strokeWidth: 22
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 136.27,
    y1: 276.8,
    x2: 136.27,
    style: {
      fill: "none",
      stroke: "#5ADACC",
      strokeMiterlimit: 10,
      strokeWidth: 22
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoreholeHovered);
export default __webpack_public_path__ + "static/media/borehole_hovered.5608da5cab167bdb2b0ec04f0f301b5d.svg";
export { ForwardRef as ReactComponent };